import { ErrorHandler } from "@angular/core";

import { AnalyticsService } from "./services/analytics.service";

/**
 * Wraps the delegate (typically Sentry's ErrorHandler) so Angular-handled
 * errors are also sent to PostHog. Browser autocapture alone can miss errors
 * caught by Angular's zone / ErrorHandler pipeline.
 *
 * Sentry runs first (same behavior as an unwrapped handler); PostHog is
 * best-effort and must not interfere if it fails.
 */
export function createPosthogWrappedErrorHandler(
  analytics: AnalyticsService,
  delegate: ErrorHandler
): ErrorHandler {
  return {
    handleError(error: unknown): void {
      delegate.handleError(error);
      try {
        analytics.captureException(error, {
          capture_source: "angular_error_handler",
        });
      } catch {
        // PostHog must never block primary error reporting
      }
    },
  };
}
